import { AxiosResponse } from "axios";
import axiosConfig from "../../../../../config/axiosConfig";

const FilterApi = () => {
  const getProjectAlls = async (params: {
    keyword?: string;
    page: string;
    size: string;
    sortBy?: string;
    sortType?: string;
    from?: string;
    to?: string;
  }): Promise<AxiosResponse<any, any>> => {
    const url = "/attendance/projects/has-timesheets";
    return await axiosConfig.get(url, { params });
  };
  const getConstructionListByProject = async (params: {
    projectId: number;
    from?: string;
    to?: string;
  }): Promise<AxiosResponse<any, any>> => {
    const url = "/attendance/constructions/has-timesheets";
    return await axiosConfig.get(url, { params });
  };

  return {
    getProjectAlls,
    getConstructionListByProject,
  };
};

export default FilterApi;
